export const DB_FIELD_MAX_LENGTH = {
  PROJECT: {
    NAME: 50,
    DESCRIPTION: 250,
    STATUS_NOTES: 2000,
    END_NOTES: 2000,
    COMMENT: 500,
  },
  GROUP: {
    NAME: 150,
    DESCRIPTION: 500,
  },
  FLAG: {
    NAME: 100,
    DESCRIPTION: 2000,
  },
  VIEW: {
    NAME: 100,
    DESCRIPTION: 500,
  },
  RESOURCE: {
    NAME: 150,
    URL: 1000,
    DESCRIPTION: 500,
  },
  USERGROUP: {
    NAME: 55,
    DESCRIPTION: 150,
  },
  ROLE: {
    NAME: 30,
    DESCRIPTION: 150,
  },
  ATTRIBUTE: {
    NAME: 500,
    GROUP_NAME: 150,
    PATTERN: 500,
    PATTERN_HINT: 150,
    FORMULA: 4000,
    COLORING_RULE: 4000,
    SQL_STATEMENT: 4000,
    IDACCESSOR: 500,
    VALUE: 500,
    TERM: 100,
    DEFAULT_TEXT: 500,
    TEMPLATE: 1000,
  },
  USER: {
    USERID: 50,
    ORACLE_USERID: 30,
    FIRSTNAME: 50,
    LASTNAME: 50,
    EMAILADRESS: 50,
  },
  GENOME: {
    NAME: 100,
    DESCRIPTION: 2000,
    IDENTIFIER: 50,
    SPECIES: 150,
    STRAIN: 150,
    DATABASE: 50,
    TAXONOMY: 50,
    KINGDOM: 50,
  },
  CARD: {
    TITLE: 50,
  },
  DATABASE: {
    NAME: 50,
    MNEMONIC: 20,
  },
  ORGANISM_PROPERTY: {
    NAME: 150,
    GROUP_NAME: 150,
    TYPE_NAME: 150,
    DESCRIPTION: 500,
  },
  PLAYBOOKS: {
    CATEGORY_NAME: 150,
  },
  EVENT: {
    NAME: 150,
    DESCRIPTION: 500,
  },
  COORD_LIST: {
    NAME: 150,
    DESCRIPTION: 500,
  },
} as const;
